import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/main-color-schemes/dark.style.ts
import { css, unsafeCSS } from "lit";
var themeDark = (targetName = ":root") => css`
    /* @Builder: skip minify */
    ${unsafeCSS(targetName)} {
        --logo-text-color: var(--color-core-white);

        --color-background-bg-active: #3d3d3d;
        --color-background-bg-body: #0e0e0e;
        --color-background-bg-critical: #f048322e;
        --color-background-bg-critical-hover: #f048323d;
        --color-background-bg-disabled: #1f1f1f;
        --color-background-bg-info: #2f8af52e;
        --color-background-bg-info-hover: #2f8af53d;
        --color-background-bg-positive: #21c1872e;
        --color-background-bg-positive-hover: #21c1873d;
        --color-background-bg-primary: #141414;
        --color-background-bg-secondary: #1f1f1f;
        --color-background-bg-tertiary: #7a7a7a;
        --color-background-bg-warning: #ff9c082e;
        --color-background-bg-warning-hover: #ff9c083d;
        --color-border-border-primary: #7a7a7a;
        --color-border-border-secondary: #3d3d3d;
        --color-border-border-tertiary: #1f1f1f;
        --color-content-content-disabled: #3d3d3d;
        --color-content-content-primary: #ffffff;
        --color-content-content-primary-inv: #1f1f1f;
        --color-content-content-secondary: #939393;
        --color-content-content-tertiary: #7a7a7a;
        --color-core-black: #181818;
        --color-core-white: #ffffff;
        --color-core-blue-info: #2f8af5;
        --color-core-blue-info-hover: #157cf4;
        --color-core-green-positive: #21c187;
        --color-core-green-positive-hover: #1ca674;
        --color-core-orange-warning: #ff9c08;
        --color-core-orange-warning-hover: #eb8d00;
        --color-core-red-critical: #f04832;
        --color-core-red-critical-hover: #ee2f16;
    }

`;
export {
  themeDark
};
//# sourceMappingURL=dark.style-IHZRPSJZ.js.map
